import React from "react";
import { motion } from "framer-motion";
import { Box, Typography, Grid, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import GroupsIcon from "@mui/icons-material/Groups";
import PrintIcon from "@mui/icons-material/Print";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import DevicesIcon from "@mui/icons-material/Devices";
import PaymentIcon from "@mui/icons-material/Payment";
import { StepContainer, FeatureCard } from "../styles";
import { stepContent } from "../content";
import { ModernButton } from "../../styled/button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4 },
  },
};

const OperationsStep = ({ onNavigate, canNavigate = true }) => {
  const theme = useTheme();
  const content = stepContent.operations;

  const featureIcons = [GroupsIcon, PrintIcon, AutoModeIcon, DevicesIcon, PaymentIcon];

  return (
    <StepContainer>
      {/* Header */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          {content.title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {content.subtitle}
        </Typography>
      </Box>

      {/* Features Grid */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {content.features.map((feature, index) => {
          const Icon = featureIcons[index];
          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                transition={{ delay: index * 0.1 }}
              >
                <FeatureCard elevation={2} color={theme.palette.success.main}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      bgcolor: (theme) =>
                        theme.palette.mode === "light"
                          ? theme.palette.success.lighter || theme.palette.success.light
                          : theme.palette.success.dark,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 1.5,
                    }}
                  >
                    <Icon sx={{ color: "success.main", fontSize: 24 }} />
                  </Box>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {feature.description}
                  </Typography>
                </FeatureCard>
              </motion.div>
            </Grid>
          );
        })}
      </Grid>

      {/* CTA */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: "auto" }}>
        <Tooltip
          title={!canNavigate ? "Apenas administradores podem acessar esta configuracao" : ""}
          placement="top"
        >
          <span>
            <ModernButton
              onClick={() => onNavigate && onNavigate(content.ctaRoute)}
              endIcon={<ArrowForwardIcon />}
              size="large"
              color="success"
              disabled={!canNavigate}
            >
              {content.ctaLabel}
            </ModernButton>
          </span>
        </Tooltip>
      </Box>
    </StepContainer>
  );
};

export default OperationsStep;
